export enum WebinarError {
  NAME_REQUIRED = 'NAME_REQUIRED',
  START_TIME_REQUIRED = 'START_TIME_REQUIRED',
  START_TIME_IN_PAST = 'START_TIME_IN_PAST',
  START_AND_END_TIME_REQUIRED = 'START_AND_END_TIME_REQUIRED',
  END_TIME_BEFORE_START_TIME = 'END_TIME_BEFORE_START_TIME',
  INVITEES_REQUIRED = 'INVITEES_REQUIRED',
  RECURRING_SESSION_ERROR = 'RECURRING_SESSION_ERROR',
  MISSING_RECURRING_SESSION_ERROR = 'MISSING_RECURRING_SESSION_ERROR',
  ADDITIONAL_SESSION_ERROR = 'ADDITIONAL_SESSION_ERROR',
  MISSING_ADDITIONAL_SESSION_ERROR = 'MISSING_ADDITIONAL_SESSION_ERROR',
}

export const WebinarErrorMessages: Record<WebinarError, string> = {
  [WebinarError.NAME_REQUIRED]: 'Webinar name is required',
  [WebinarError.START_TIME_REQUIRED]: 'At least one webinar session must be configured',
  [WebinarError.START_TIME_IN_PAST]: 'Webinar start time cannot be in the past',
  [WebinarError.START_AND_END_TIME_REQUIRED]: 'At least one start and end time is required',
  [WebinarError.END_TIME_BEFORE_START_TIME]: 'Webinar end time cannot be before the start time',
  [WebinarError.INVITEES_REQUIRED]: 'Webinar must have at least one invitee',
  [WebinarError.RECURRING_SESSION_ERROR]: 'There is an error with an added recurring session',
  [WebinarError.MISSING_RECURRING_SESSION_ERROR]: 'At least one recurring session must be added',
  [WebinarError.ADDITIONAL_SESSION_ERROR]: 'There is an error with an added additional session',
  [WebinarError.MISSING_ADDITIONAL_SESSION_ERROR]: 'At least one additional session must be added',
};
